<template>
    <div>
        <v-card>
            <v-card-title class="blue-grey white--text" style="height: 50px;">
                <span class="mt-n2">IMPORTACIÓN</span>
            </v-card-title>
            <v-card-text>
                <v-form>
                    <v-container>
                        <v-row class="mt-5">
                            <v-col cols="12" md="4">
                                <v-row>
                                    <v-col cols="12" md="10" class="form-space">
                                        <v-text-field v-model="proveedor" label="Proveedor" outlined dense disabled filled></v-text-field>
                                        <h4 class="ml-2 mt-n7">{{ rut }}</h4>
                                    </v-col>
                                    <v-col cols="4" md="2" class="form-space">
                                        <v-btn class="mt-2" @click="d_proveedor=true" small color="indigo" dark rounded>
                                            <v-icon small>find_replace</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" md="4" class="form-space">
                                <v-sheet class="mt-n2" style="border: 1px solid lightgray;" height="60" rounded>
                                    <v-row>
                                        <v-col cols="12" md="6" class="mt-2 text-center">
                                            <v-btn @click="search_solicitud()" class="mt-2" x-small color="indigo" dark rounded height="25">
                                                <span>agregar solicitud</span>
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" md="6" class="mt-2 text-center">
                                            <v-btn  @click="search_editar()" class="mt-2" x-small color="info" dark rounded height="25">
                                                <span>modificar solicitud</span>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="2" class="form-space">
                                <v-text-field v-model="numero" label="Numero Solicitud" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="2" class="form-space">
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="date1" label="Fec. Ingreso" prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date1" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" class="mt-n10">
                                <v-container>
                                    <v-row>
                                        <v-col cols="6" md="2">
                                            <h5 @click="inventa=true">Agregar Sku <v-icon color="success">add_circle</v-icon></h5>
                                        </v-col>
                                    </v-row>
                                    <v-row class="mt-2">
                                        <v-col cols="12" md="12" class="mt-n5">
                                            <v-data-table dense dark fixed-header height="230" 
                                                :headers="detalle_head" 
                                                :items="detalle_items" 
                                                :page.sync="page" 
                                                :items-per-page="itemsPerPage" 
                                                hide-default-footer 
                                                class="elevation-1 text-size" 
                                                @page-count="pageCount = $event">
                                                <template v-slot:item.accion="{ item }">
                                                    <v-icon @click="editItem(item)" small>edit</v-icon>
                                                    &nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
                                                    <v-icon @click="deleteItem(item.id)" small>delete</v-icon>
                                                </template>
                                            </v-data-table>
                                        </v-col>
                                    </v-row>                                
                                </v-container>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions style="margin-top:-25px">
                <v-row>
                    <v-col cols="12" md="5">
                        <v-row>
                            <v-col cols="12" md="3"></v-col>
                            <v-col cols="12" md="5" class="text-right">
                                <v-text-field v-model="alias" label="Alias" outlined dense disabled filled></v-text-field>
                            </v-col>
                            <v-col cols="12" md="1">
                                <!-- <v-text-field v-model="fecha" label="Fec. Solicitud" prepend-icon="mdi-calendar" dense outlined disabled filled></v-text-field> -->
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="7">
                        <v-row>
                            <v-col cols="12" md="4" class="text-end"></v-col>
                            <v-col cols="12" md="3" class="mt-2">
                                <v-btn @click="clsInput()" class="ml-2" small color="teal" dark rounded block><v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span></v-btn>
                            </v-col>
                            <v-col cols="12" md="3" class="mt-2">
                                <div v-if="div_btn=='save'">
                                    <v-btn v-if="btn_grabar==true" @click="save_solicitud()" class="ml-2" small color="teal" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn>                
                                    <v-btn v-else class="ml-2" small color="grey" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Grabar</span></v-btn>
                                </div>
                                <div v-if="div_btn=='update'">
                                    <v-btn v-if="btn_modifica==true" @click="update_solicitud()" class="ml-2" small color="teal" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Modificar</span></v-btn>                
                                    <v-btn v-else class="ml-2" small color="grey" dark rounded block><v-icon small>save</v-icon><span class='text-btn'>Modificar</span></v-btn>
                                </div>
                            </v-col>
                            <v-col cols="12" md="2"></v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>

        <!-- dialog inventa --> 
        <v-dialog v-model="inventa" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="inventa=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleProductos" dense dark :search="inventasearch" :headers="inventatitulo" 
                        :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  
                        @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>

        <!-- dialog Solicitudes --> 
        <v-dialog v-model="solicita" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="solicita=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <h6 v-if="press_btn=='update'">{{proveedor}}</h6>                
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="solicitasearch" label="Buscar Producto" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleSolicita" dense dark :search="solicitasearch" :headers="solicitatitulo" 
                        :items="solicitalista" :page.sync="solicitapage" :items-per-page="solicitaitemsPerPage"  
                        @page-count="solicitapageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialog proveedores --> 
        <v-dialog v-model="d_proveedor" transition="dialog-bottom-transition" max-width="60%" persistent>
            <v-card>
                <v-card-title>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-btn @click="d_proveedor=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                        </v-col>
                        <v-col cols="6" md="5">
                            <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                        </v-col>
                        <v-col cols="12" md="4" class="text-right">
                            <v-text-field class='ml-5 mr-2 text-caption' v-model="proveedorsearch" label="Buscar Producto" dense required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <v-data-table @click:row="handleProveedor" dense dark :search="proveedorsearch" :headers="proveedortitulo" 
                        :items="proveedorlista" :page.sync="proveedorpage" :items-per-page="proveedoritemsPerPage"  
                        @page-count="proveedorpageCount = $event" hide-default-footer class="elevation-1 text-size" fixed-header height="300">
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialogo Valoriza -->
        <v-dialog v-model="d_valoriza" transition="dialog-bottom-transition" max-width="50%" persistent>
            <v-card>
            <v-card-text>
                <v-row class="mt-5">
                    <v-col cols="12" md="12" class="text-center">
                        <v-alert class='text-caption' dense text type="success">
                            <div style="float:left;">SKU: <span class="black--text">{{ sku }}</span></div>
                            <div style="float:right;">PRODUCTO: <span class="black--text">{{ nombre }}</span></div>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="4">
                        <v-text-field v-model="val_codigo" label="Cod. Proveedor" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field @keypress="onlyDecimal" v-model="val_precio" label="Precio" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field @keypress="onlyNumber" v-model="val_cantidad" label="Cantidad" outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-btn @click="add_valoriza()" small fab dark color="indigo"><v-icon>playlist_add</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider class="mt-2 mb-2"></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="d_valoriza=false" color="indigo">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"/>
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 33px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
.form-space {
    margin-top:-20px;
}
</style>
<script>
import axios from 'axios';
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
export default {
    name:'Importa', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            //contrato:'123',
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            rut:'',
            proveedor:'',

            sku:'',
            nombre:'',
            universal:'',
            cantidad:'',
            numero:0,
            alias:'',
            menu1:false,
            date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            fecha:'',
            idItems:0,
            //detalle solicitud
            page: 1,
            pageCount: 0,
            itemsPerPage: 1000000,
            detalle_head:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
                { text: 'Cod. Universal', align: 'center', sortable: true, value: 'universal' },
                { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
                { text: 'Cantidad', align: 'center', sortable: true, value: 'cantidad' },
                { text: 'Cod.Proveedor', align: 'center', sortable: true, value: 'codigo' },
                { text: 'Precio', align: 'center', sortable: true, value: 'precio' },
                { text: 'Editar / Borrar', align: 'center', sortable: false, value: 'accion' },
            ],
            detalle_items:[],
            //lista productos
            inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku', width:'' },
                { text: 'Cod. Barra', align: 'start', sortable: true, value: 'barraSku' },
                { text: 'Cod. Universal', align: 'start', sortable: true, value: 'universalSku' },
                { text: 'Producto', align: 'start', sortable: true, value: 'nameSku' },
                { text: 'Medida', align: 'start', sortable: true, value: 'medidaSku' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 1000000,
            //lista solicitudes
            solicita:false,
            solicitasearch:'',
            solicitatitulo:[
                { text: 'Fecha', align: 'start', sortable: true, value: 'fecha', width:'' },
                { text: 'Numero', align: 'start', sortable: true, value: 'numero' },
                { text: 'Alias', align: 'start', sortable: true, value: 'alias' },
            ],
            array_solicitud:[],
            solicitalista:[],
            solicitapage: 1,
            solicitapageCount: 0,
            solicitaitemsPerPage: 1000000,
            //lista proveedores
            d_proveedor:false,
            proveedorsearch:'',
            proveedortitulo:[
                { text: 'Rut', align: 'start', sortable: true, value: 'rut', width:'' },
                { text: 'Proveedor', align: 'start', sortable: true, value: 'razon' },
            ],
            proveedorlista:[],
            proveedorpage: 1,
            proveedorpageCount: 0,
            proveedoritemsPerPage: 1000000,

            div_btn:'save',
            btn_grabar:true,
            btn_modifica:true,
            btn_print:false,
            d_valoriza:false,
            val_cantidad:0,
            val_precio:0,
            val_codigo:'',
            id_lista:0,
            press_btn:'save',
        }
    },
    async mounted(){
        this.loading=true;
        await this.buscarProveedor();
        await this.buscarProducto();
        this.loading=false;
    },
    methods:{
        clsInput(){
            this.detalle_items=[];
            this.numero=0;
            this.alias='';
            this.clsproducts();
            this.div_btn='save';
            this.btn_grabar=true;
            this.btn_modifica=true;
            this.btn_print=false;
            this.press_btn='save';
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.proveedor='';
            this.rut='';
        }, 
        clsproducts(){
            this.sku='';
            this.nombre='';
            this.universal='';
            this.cantidad='';
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        async buscarProveedor(){
            this.proveedorlista=[];
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/proveedores/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.proveedorlista.push({
                            'rut': element.Rut,
                            'razon': element.Razon 
                        })                        
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async handleProveedor(line){
            this.detalle_items=[];
            this.numero=0;
            this.alias='';
            this.date1=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.div_btn='save';
            this.proveedor = line.razon;
            this.rut = line.rut;
            this.d_proveedor = false;
        },
        async buscarProducto(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
                const datos=response.data;
                this.inventalista=[];
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.inventalista.push({
                            sku:element.Sku,
                            barraSku:element.Barra,
                            universalSku:element.Universal,
                            nameSku:element.Nombre,
                            medidaSku:element.Medida
                        });                    
                    });
                }                
            } catch (error) {
                console.log(error)
            }
        },
        handleProductos(fila) {
            //buscamos sku en la lista
            if(this.rut!='' && parseInt(this.numero)!=0){
                this.sku = fila.sku;
                this.nombre = fila.nameSku;
                this.universal = fila.universalSku;
                this.addItem();
            } else {
                this.Msg='ingrese proveedor y solicitud'
                this.color='red';
                this.msgbox=true;
                this.showSnack();

            };
            this.inventa=false;
        },
        addItem(){
            if(this.sku.trim()!='' && this.universal!=''){
                this.idItems++
                this.detalle_items.push({
                    'id':this.idItems,
                    'sku': this.sku,
                    'universal': this.universal,
                    'producto':this.nombre,
                    'cantidad':0,
                    'codigo':'',
                    'precio':''
                });
            }
        },
        deleteItem(n){
            this.detalle_items = this.detalle_items.filter(function(dat) {
                return dat.id !== n; 
            });
        },
        async save_solicitud(){
            this.loading=true;       
            try {
                if(this.detalle_items.length!=0 && this.rut!='' && parseInt(this.numero)!=0){
                    let total_save = 0;
                    for (let index = 0; index < this.detalle_items.length; index++) {
                        const element = this.detalle_items[index];
                        const params={
                            'contrato': this.contrato,
                            'numero': this.numero,
                            'sku': element.sku,
                            'universal':element.universal,
                            'cantidad':element.cantidad,
                            'estado':'V',
                            'usuario':this.usu,
                            'fecha': this.date1,
                            'alias': this.alias,
                            'rut': this.rut,
                            'codigo': element.codigo,
                            'precio': element.precio
                        };
                        const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/importa/',params);
                        const datos=response.data;
                        if (datos=='si'){
                            total_save = parseInt(total_save) + 1;
                        }
                    }
                    if(parseInt(total_save)!=0){
                        this.Msg='Importacion generada con exito'
                        this.color='success';
                        this.msgbox=true;
                        this.showSnack();
                        this.btn_grabar=false;
                        this.btn_print=true;
                    } else {
                        this.Msg='No se ha grabado la importacion, intentelo mas tarde'
                        this.color='red';
                        this.msgbox=true;
                        this.showSnack();
                    }
                } else {
                    this.Msg='Faltan Datos para grabar la importacion'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } catch (error) {
               console.log(error) 
            }
            this.loading=false;
        },
        async search_solicitud(){
            if(this.rut!=''){
                this.press_btn='save';
                this.loading=true;
                this.array_solicitud=[];
                this.solicitalista=[];
                try {
                    const get_number = 'all';
                    const par_get = this.contrato + '/' + get_number; 
                    const res_number = await axios.get(process.env.VUE_APP_URL + '/api/inv/solicitud/' + par_get);
                    const data_number=res_number.data;
                    if (data_number[0].existe=='si'){
                        this.array_solicitud = data_number;
                        let myNumber = 0;
                        this.array_solicitud.forEach(element => {
                            if(parseFloat(myNumber)!=parseFloat(element.Numero)){
                                this.solicitalista.push({
                                    'fecha': element.Fecha,
                                    'numero': element.Numero,
                                    'alias': element.Alias
                                })
                            }
                            myNumber = element.Numero;
                        });
                    }
                    this.solicita=true;
                } catch (error) {
                    console.log(error)
                }
                this.loading=false;
                this.solicita=true;
            } else {
                this.Msg='Debe seleccionar un proveedor'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
        },
        async valida_importa(numero){
            let result = false
            try {
                const rut_importa = this.rut;
                const estado_importa = 'V';
                const par_importa = this.contrato + '/' + rut_importa + '/' + estado_importa; 
                const res_importa = await axios.get(process.env.VUE_APP_URL + '/api/inv/importa/' + par_importa);
                const data_importa=res_importa.data;
                if (data_importa[0].existe=='si'){
                    data_importa.forEach(element => {
                        if(parseFloat(element.Numero)==parseFloat(numero)){
                            result = true;
                        }
                    });
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async handleSolicita(fila) {
            //validar si existe importacion
            let valid_import = false;
            if(this.press_btn=='save'){
                valid_import = await this.valida_importa(fila.numero);
            }
            if(!valid_import){
                this.detalle_items=[];
                const filter = this.array_solicitud.filter(res => parseFloat(res.Numero) == parseFloat(fila.numero));
                if(filter.length!=0){
                    let myCode = '';
                    let myPrice = 0;
                    filter.forEach(element => {
                        if(this.press_btn=='update'){
                            myCode = element.Pro_Codigo;
                            myPrice = element.Precio;
                            this.div_btn = 'update'
                        } else {
                            this.div_btn = 'save'
                        };
                        this.detalle_items.push({
                            'id': element.ID,
                            'sku': element.Sku,
                            'universal': element.Universal,
                            'producto': element.Producto,
                            'cantidad': element.Cantidad,
                            'precio':myPrice,
                            'codigo':myCode
                        });
                    });
                    this.numero = filter[0].Numero;
                    this.fecha = filter[0].Fecha;
                    this.alias = filter[0].Alias;
                }
            } else {
                this.Msg='La solicitud ya existe para el proveedor seleccionado'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
            this.solicita=false;
        },
        async update_solicitud(){
            this.loading=true;
            try {
                if(this.detalle_items.length!=0 && this.alias!='' && this.alias!=null && parseFloat(this.numero)!=0){
                    //eliminamos la solicitud
                    const par_del = this.contrato + '/' + this.numero + '/' + this.rut; 
                    const res_del = await axios.delete(process.env.VUE_APP_URL + '/api/inv/importa/' + par_del);
                    const data_del=res_del.data;
                    if(data_del=='si'){
                        //grabar la nueva solicitud
                        let total_save = 0;
                        for (let index = 0; index < this.detalle_items.length; index++) {
                            const element = this.detalle_items[index];
                            const params={
                                'contrato': this.contrato,
                                'numero': this.numero,
                                'sku': element.sku,
                                'universal':element.universal,
                                'cantidad':element.cantidad,
                                'estado':'V',
                                'usuario':this.usu,
                                'fecha': this.date1,
                                'alias': this.alias,
                                'rut': this.rut,
                                'codigo': element.codigo,
                                'precio': element.precio
                            };
                            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/importa/',params);
                            const datos=response.data;
                            if (datos=='si'){
                                total_save = parseInt(total_save) + 1;
                            }
                        };
                        if(parseFloat(total_save)!=0){
                            this.Msg='La importacion se ha modificado con exito'
                            this.color='success';
                            this.msgbox=true;
                            this.showSnack();
                            this.btn_modifica=false;
                            this.btn_print=true;
                        } else {
                            this.Msg='Datos corruptos, ya no existen registros de esta importacion'
                            this.color='red';
                            this.msgbox=true;
                            this.showSnack();                               
                        }
                    } else {
                        this.Msg='No es posible modificar la importacion'
                        this.color='red';
                        this.msgbox=true;
                        this.showSnack();
                    }
                } else {
                    this.Msg='Faltan datos para modificar la importacion'
                    this.color='red';
                    this.msgbox=true;
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
            this.loading=false;
        },
        async editItem(line){
            this.sku=line.sku;
            this.nombre=line.producto;
            this.id_lista=line.id;
            this.val_cantidad=line.cantidad;
            this.val_precio=line.precio;
            this.val_codigo=line.codigo;
            this.d_valoriza=true;
        },
        async add_valoriza(){
            const found =  this.detalle_items.filter(res => res.sku == this.sku && res.id == this.id_lista);
            if(found.length!=0){
                found[0].cantidad = this.val_cantidad;
                found[0].precio = this.val_precio;
                found[0].codigo = this.val_codigo;
            };
            this.d_valoriza=false;
        },
        async search_editar(){
            if(this.rut!=''){
                this.press_btn='update';
                this.loading=true;
                this.array_solicitud=[];
                this.solicitalista=[];
                try {
                    const rut_importa = this.rut;
                    const estado_importa = 'V';
                    const par_importa = this.contrato + '/' + rut_importa + '/' + estado_importa; 
                    const res_importa = await axios.get(process.env.VUE_APP_URL + '/api/inv/importa/' + par_importa);
                    const data_importa=res_importa.data;
                    if (data_importa[0].existe=='si'){
                        this.array_solicitud = data_importa;
                        let myNumber = 0;
                        this.array_solicitud.forEach(element => {
                            if(parseFloat(myNumber)!=parseFloat(element.Numero)){
                                this.solicitalista.push({
                                    'fecha': element.Fecha,
                                    'numero': element.Numero,
                                    'alias': element.Alias
                                })
                            }
                            myNumber = element.Numero;
                        });
                    }
                    this.solicita=true;
                } catch (error) {
                    console.log(error)
                }
                this.loading=false;
                this.solicita=true;
            } else {
                this.Msg='Debe seleccionar un proveedor'
                this.color='red';
                this.msgbox=true;
                this.showSnack();
            }
        },


    }

}
</script>